import AgoraRTC from "agora-rtc-react";
import VirtualBackgroundExtension from "agora-extension-virtual-background";

export const virtualBackgroundExtension = new VirtualBackgroundExtension();

let extensionRegistered = false;

export const registerAgoraVirtualBackground = () => {
  if (extensionRegistered) {
    return;
  }

  if (!virtualBackgroundExtension.checkCompatibility()) {
    return;
  }

  AgoraRTC.registerExtensions([virtualBackgroundExtension]);
  extensionRegistered = true;
};

export const isVirtualBackgroundSupported = () =>
  virtualBackgroundExtension.checkCompatibility();
